import {Vote} from "../../model/Vote";
import {CacheState} from "./CacheState";

export class ReportVoteState implements CacheState {
    constructor(public reportId: number | undefined = undefined,
                public vote: Vote | null | undefined = undefined,
                public pendingRequest: boolean = false,
                public loaded: boolean = false) {
    }
}